<template>
  <div :class="{list: true, required}">
    <div class="left">{{ label }}</div>
    <div class="value">
      <slot></slot>
    </div>
    <div class="arr" v-if="arr">
      <Icon name="arrow" color="#5D6067" size="0.6rem" />
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';
export default {
  components: { Icon },
  props: ['label', 'arr', 'required'],
};
</script>

<style lang="less" scoped>
.list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 90px;
  background-color: white;
  border-bottom: solid 1px #f7f9fa;

  &.required {
    .left:before {
      content: '*';
      position: absolute;
      left: 5px;
      color: red;
    }

  }

  &.margin {
    margin-bottom: 20px;
  }

  .left {
    width: 228px;
    font-size: 32px;
    color: #3d424d;
    letter-spacing: 0;
    line-height: 38px;
    padding-left: 30px;
    text-align: left;
    box-sizing: border-box;
    position: relative;
  }
  .value {
    width: calc(100% - 228px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }
  .arr {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 20px;
  }
}
</style>
